import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        settings: '<'
    },
    template: `
        <ul class="tabs01">
            <li ng-repeat="tab in vm.settings.tabs" ng-if="tab.isEnabled">
                <span ng-class="{'active': vm.settings.activeTabId === tab.id}">{{ tab.title }} </span>
            </li>
        </ul>
        <div class="well type02">
            <div class="colholder mt1em">
                <div class="col col09 pt0">
                    <ul class="toc-menu01">
                        <li class="item skeleton" style="height:50px;"></li>
                    </ul>
                </div>
                <div class="col col05 pt0 ng-scope">
                    <div class="form">
                            <div class="block07">
                            <div class="row row-wide skeleton" style="width:50%; height:50px; border-radius:10px;">
                                <label class="label skeleton">&nbsp;</label>
                            </div>
                        </div>

                        <div class="block07 mt20">
                            <div class="row row-wide skeleton" style="width:50%; height:50px; border-radius:10px;">
                                <label class="label skeleton">&nbsp;</label>
                            </div>
                        </div>

                        <div class="block07 mt20">
                                    <div class="row row-wide skeleton" style="width:50%; height:50px; border-radius:10px;">
                                <label class="label skeleton">&nbsp;</label>
                            </div>
                        </div>

                        <div class="block02 type02 skeleton" style="height:20px;"></div>
                    </div>
                </div>
            </div>
        </div>

    `
})

export default class {}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/steps/version/training/skeleton/index.js